import {
  getRegisteredAssetManifest,
  type GameAssetManifest,
} from '@core/Assets/assetManifestRegistry';
import { getGameFromUrl } from '@core/utils/urlParser';

export type AssetManifest = GameAssetManifest;

const SKY_SNIFFER_SLUGS = new Set([
  'skysniffer',
  'sky-sniffer',
  'sky-sniffer-v2',
]);

export function isSkySnifferGame(slug: string): boolean {
  return SKY_SNIFFER_SLUGS.has(slug);
}

function resolveRegisteredManifest(
  gameSlug: string
): GameAssetManifest | undefined {
  const routeSlug = getGameFromUrl();
  const candidates = [
    gameSlug,
    routeSlug,
    'crash',
    'skysniffer',
    'sky-sniffer',
  ].filter((slug): slug is string => Boolean(slug));
  for (const slug of candidates) {
    const manifest = getRegisteredAssetManifest(slug);
    if (manifest) {
      return manifest;
    }
  }
  return undefined;
}

/**
 * Get the asset manifest for a given game slug
 */
export function getAssetManifest(
  gameSlug: string,
  manifestOverride?: AssetManifest
): AssetManifest {
  if (manifestOverride) {
    return manifestOverride;
  }
  return resolveRegisteredManifest(gameSlug) ?? { images: {} };
}

/**
 * Get an image asset path for a given game slug and asset key
 */
export function getImageAsset(
  gameSlug: string,
  assetKey: string,
  manifestOverride?: AssetManifest
): string {
  const manifest = getAssetManifest(gameSlug, manifestOverride);
  return manifest.images[assetKey] || '';
}
